import React, {useState} from 'react';
import {View} from 'react-native';
import PropTypes from 'prop-types';
import sy from '~/styles';
import {
  Text,
  PrivateText,
  FormTextInput,
  PhoneNumberInput,
  EmailInput,
} from '~/components/controls';
import {Row, EditDialog} from '~/components/controls/3/Grouping';
import WarningIcon from '~/images/md-icons/warning/materialicons/18px.svg';

const FIELDS = [
  ['client_initials', 'Voorletter(s)', FormTextInput],
  ['client_first_name', 'Voornaam', FormTextInput],
  ['client_last_name', 'Achternaam', FormTextInput],
  ['phone_number', 'Mobiele telefoon', PhoneNumberInput],
  ['email', 'E-mail', EmailInput],
];

const ClientField = ({
  field,
  title,
  Input,
  initialValue,
  missing,
  onUpdateRequest,
}) => {
  const [value, setValue] = useState(null);
  const phone = field === 'phone_number';
  const color = missing ? '#FF6C00' : '#4a4a49';
  return (
    <Row
      title={
        phone ? (
          <View style={[sy['flex-row'], sy['items-center']]}>
            <Text>{title}</Text>
            {missing && (
              <>
                &nbsp;
                <WarningIcon fill="#FF6C00" />
              </>
            )}
          </View>
        ) : (
          title
        )
      }
      linkStyle={phone ? {color} : undefined}
      onEditClicked={() => setValue(initialValue)}>
      <PrivateText style={phone ? {color} : undefined}>
        {initialValue || <>Opgeven</>}
      </PrivateText>
      <EditDialog
        title={title}
        dismissable
        cancelButton
        onOK={async () => {
          await onUpdateRequest({[field]: value});
        }}>
        <View style={[sy['p-4']]}>
          <div data-private>
            <Input
              label={phone ? 'Nummer' : title}
              value={initialValue}
              {...(Input === FormTextInput
                ? {onEndEditing: setValue}
                : {onChange: setValue})}
            />
          </div>
        </View>
      </EditDialog>
    </Row>
  );
};
ClientField.propTypes = {
  field: PropTypes.string,
  title: PropTypes.string,
  Input: PropTypes.elementType,
  initialValue: PropTypes.any,
  missing: PropTypes.bool,
  onUpdateRequest: PropTypes.func,
};

const ClientFields = ({
  overview,
  phone_number_missing = false,
  onUpdateRequest,
}) => (
  <>
    {FIELDS.map(([field, title, Input]) => (
      <ClientField
        key={field}
        field={field}
        title={title}
        Input={Input}
        initialValue={overview?.[field]}
        missing={field === 'phone_number' && phone_number_missing}
        onUpdateRequest={onUpdateRequest}
      />
    ))}
  </>
);
ClientFields.propTypes = {
  overview: PropTypes.any,
  phone_number_missing: PropTypes.bool,
  onUpdateRequest: PropTypes.func,
};
export default ClientFields;
